import StatusButton from "./StatusButton";
import CustomTable from "../table";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import { useAccess } from "../../provider/AccessProvider";

export default function ActiveTable({ data, subscriptionStatus }) {
  const currencyFormatter = useCurrency();
  const access = useAccess(["cancelSubscription"]);
  const country = useCountry();
  const columns = [
    {
      title: "Order id",
      dataIndex: "orderId",
    },
    {
      title: "SUBSCRIPTION",
      dataIndex: "subscriptionName",
    },
    {
      title: "Customer",
      dataIndex: "customerName",
    },
    {
      title: "Customer",
      dataIndex: "customerPhoneNumber",
    },
    {
      title: `TOTAL(${country.CurrencySymbol})`,
      field: "totalAmount",
      render: (rowData) => {
        return <span>{currencyFormatter(rowData.totalAmount)}</span>;
      },
    },
    {
      title: "START DATE",
      dataIndex: "subscriptionStartDate",
    },
    {
      title: "END DATE",
      dataIndex: "subscriptionEndDate",
    },
    {
      title: "NEXT PAYMENT",
      dataIndex: "subscriptionRenewalDate",
    },
    {
      title: "Instructions",
      dataIndex: "instructionsToKitchen",
    },
    {
      title: "STATUS",
      render: (rowData) => {
        return (
          <>
            <div
              style={{
                textAlign: "center",
              }}
            >
              <StatusButton status={rowData.subscriptionStatus}>
                {rowData.subscriptionStatus}
              </StatusButton>
            </div>
            <div
              style={{
                textAlign: "center",
                whiteSpace: "nowrap",
              }}
            >
              <button
                style={{
                  color: "#5194C6",
                  border: "0",
                  background: "transparent",
                  fontSize: "0.75rem",
                }}
                variant="text"
                onClick={() => {
                  if (!access.cancelSubscription()) {
                    return;
                  }
                  subscriptionStatus("cancelled", rowData.billId);
                }}
              >
                Cancel
              </button>
            </div>
          </>
        );
      },
    },
    // {
    //   title: "INVOICE",
    //   field: "invoice",
    //   render: (rowData) => {
    //     return (
    //       <button
    //         style={{
    //           color: "#5194C6",
    //           border: "0",
    //           background: "transparent",
    //           fontSize: "14px",
    //         }}
    //         variant="text"
    //       >
    //         View
    //       </button>
    //     );
    //   },
    // },
  ];
  return (
    <CustomTable
      title={"Current Subscriptions"}
      columns={columns}
      data={data}
    />
  );
}
